import type { FC, ReactNode } from 'react';
import { FeatureFlag, useFeatureFlag } from '../../hooks/useFeatureFlag';

interface SmartSearchCheckerProps {
  children: ReactNode;
}

export const SmartSearchChecker: FC<SmartSearchCheckerProps> = ({ children }) => {
  const { enabled } = useFeatureFlag(FeatureFlag.SmartSearch);

  if (!enabled) {
    return null;
  }

  return <>{children}</>;
};
